// tslint:disable
export enum ProgramPartyType {
    /**
     * @description UNKNOWN
     */
    UNKNOWN = 0,
    /**
     * @description PERSON
     */
    PERSON = 1,
    /**
     * @description ORGANIZATION
     */
    ORGANIZATION = 2,
    /**
     * @description OTHERS
     */
    OTHERS = 3,
    /**
     * @description Placeholder for nonentity
     */
    PlaceholderForNonentity = 4,
}
(ProgramPartyType as any)['PLACEHOLDERFORNONENTITY'] = 4;
